import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@mui/material';
import './styles/loadingSpinner.scss';

export default function LoadingSpinner({ className, size }) {
  let spinnerClassName = 'spinner';
  if (className) {
    spinnerClassName += ' ' + className;
  }
  return (
    <div className={spinnerClassName}>
      <CircularProgress size={size} />
    </div>
  );
}

LoadingSpinner.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number
};
